export var footerContainerStyle = {
    background: "#003C78",
    borderRadius: 20,
    color: "#FFFFFF",
    marginTop: 32,
    padding: 24,
};
export var footerTopStyle = {
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    gap: 16,
    justifyContent: "space-between",
};
export var footerLinksStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: 16,
    listStyle: "none",
    margin: 0,
    padding: 0,
};
export var footerLinkStyle = {
    color: "#FFFFFF",
    fontSize: 12,
    textDecoration: "none",
};
export var footerBrandStyle = {
    alignItems: "flex-end",
    display: "flex",
    flexDirection: "column",
    gap: 4,
};
export var footerTextStyle = {
    color: "#FFFFFF",
};
export var defaultFooterDividerStyle = {
    border: 0,
    borderTop: "1px solid #FFFFFF",
    margin: "20px 0",
};
export var publicFooterStyle = {
    background: "#0034B7",
    color: "#F8FAFC",
    padding: "64px 32px",
    width: "100%",
};
export var publicFooterContentStyle = {
    display: "grid",
    gap: 48,
    margin: "0 auto",
    maxWidth: 1376,
    width: "100%",
};
export var publicFooterTopStyle = {
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    gap: 29,
    justifyContent: "space-between",
};
export var publicFooterLinksStyle = {
    display: "flex",
    flex: "1 1 360px",
    flexWrap: "wrap",
    gap: 32,
    listStyle: "none",
    margin: 0,
    padding: 0,
};
export var publicFooterLinkStyle = {
    color: "#F8FAFC",
    fontSize: 12,
    lineHeight: 1.5,
    textDecoration: "none",
};
export var publicFooterBrandRowStyle = {
    alignItems: "center",
    display: "flex",
    flex: "0 1 auto",
    flexWrap: "wrap",
    gap: 24,
    justifyContent: "flex-end",
};
export var publicAgencyTextStyle = {
    color: "#FFFFFF",
    fontSize: 12,
    lineHeight: "16px",
    maxWidth: 130,
    textAlign: "right",
};
export var publicBrasaoImageStyle = {
    display: "block",
    height: 68,
    width: 68,
};
export var publicGovPeImageStyle = {
    display: "block",
    height: 69,
    width: 85,
};
export var publicLigaImageStyle = {
    display: "block",
    height: 54,
    width: 128,
};
export var publicFooterBottomStyle = {
    display: "grid",
    gap: 16,
};
export var publicFooterDividerStyle = {
    border: 0,
    borderTop: "1px solid #F8FAFC",
    margin: 0,
};
export var publicFooterInfoStyle = {
    color: "#F8FAFC",
    fontSize: 12,
    lineHeight: 1.5,
    margin: 0,
};
